import * as React from "react";
import type { SVGProps } from "react";
const SvgPersonAtReception = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M7.5 8c1.33 0 2.44-1.04 2.51-2.38l.06-1.09C10.07 3.13 8.94 2 7.45 2 6.06 2 4.92 3.13 4.92 4.59l.06 1.04a2.527 2.527 0 0 0 2.51 2.38zm.05-4c.29 0 .53.24.53.47l-.06 1.04C8 5.78 7.78 6 7.5 6s-.5-.21-.52-.49l-.06-.98c0-.29.24-.53.62-.53zM16.5 8c1.33 0 2.44-1.04 2.51-2.38l.06-1.09c0-1.4-1.13-2.53-2.62-2.53-1.39 0-2.53 1.13-2.53 2.59l.06 1.04a2.527 2.527 0 0 0 2.51 2.38zm.05-4c.29 0 .53.24.53.47l-.06 1.04c-.02.27-.24.49-.52.49s-.5-.21-.52-.49l-.06-.98c0-.29.24-.53.62-.53zM20 12.92h2c.55 0 1 .45 1 1v7c0 .55-.45 1-1 1s-1-.45-1-1v-6H11V15c0 .27-.1.52-.29.71l-.71.71v4.59c0 .55-.45 1-1 1s-1-.45-1-1v-5c0-.27.1-.52.29-.71l.71-.71V11H6v3.59l.71.71c.18.19.29.44.29.71v5c0 .55-.45 1-1 1s-1-.45-1-1v-4.59l-.71-.71C4.11 15.52 4 15.27 4 15v-.08H3v6c0 .55-.45 1-1 1s-1-.45-1-1v-7c0-.55.45-1 1-1h2V11c0-1.1.9-2 2-2h3c1.1 0 2 .9 2 2v1.92h2V11c0-1.1.9-2 2-2h3c1.1 0 2 .9 2 2zm-2 0V11h-3v1.92z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgPersonAtReception;
